/*
 *
 * Itinerary actions
 *
 */

const SCOPE = 'app/Itinerary/';
export const ActionTypes = {
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_QUERY: `${SCOPE}SET_QUERY`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_ITINERARY_ACTIVITIES_IS_LOADED: `${SCOPE}SET_ITINERARY_ACTIVITIES_IS_LOADED`,
    SET_ITINERARY_ACTIVITIES_HAS_MORE: `${SCOPE}SET_ITINERARY_ACTIVITIES_HAS_MORE`,
    SET_ITINERARY_ACTIVITIES_OFFSET: `${SCOPE}SET_ITINERARY_ACTIVITIES_OFFSET`,
    SET_ITINERARY_ACTIVITIES_PROMOPRICES: `${SCOPE}SET_ITINERARY_ACTIVITIES_PROMOPRICES`,
    FETCH_ITINERARY_ACTIVITIES: `${SCOPE}FETCH_ITINERARY_ACTIVITIES`,
    FETCH_ITINERARY_ACTIVITIES_STARTED: `${SCOPE}FETCH_ITINERARY_ACTIVITIES_STARTED`,
    FETCH_ITINERARY_ACTIVITIES_SUCCESSFULLY: `${SCOPE}FETCH_ITINERARY_ACTIVITIES_SUCCESSFULLY`,
    FETCH_ITINERARY_ACTIVITIES_FAILED: `${SCOPE}FETCH_ITINERARY_ACTIVITIES_FAILED`,
    FETCH_ITINERARY_ACTIVITIES_CANCELLED: `${SCOPE}FETCH_ITINERARY_ACTIVITIES_CANCELLED`,
    SET_ITINERARY_PRELOADED: `${SCOPE}SET_ITINERARY_PRELOADED`,

    SET_CATEGORY_ACTIVITIES_IS_LOADED: `${SCOPE}SET_CATEGORY_ACTIVITIES_IS_LOADED`,
    SET_CATEGORY_ACTIVITIES_HAS_MORE: `${SCOPE}SET_CATEGORY_ACTIVITIES_HAS_MORE`,
    SET_CATEGORY_ACTIVITIES_OFFSET: `${SCOPE}SET_CATEGORY_ACTIVITIES_OFFSET`,
    FETCH_CATEGORY_ACTIVITIES: `${SCOPE}FETCH_CATEGORY_ACTIVITIES`,
    FETCH_CATEGORY_ACTIVITIES_STARTED: `${SCOPE}FETCH_CATEGORY_ACTIVITIES_STARTED`,
    FETCH_CATEGORY_ACTIVITIES_SUCCESSFULLY: `${SCOPE}FETCH_CATEGORY_ACTIVITIES_SUCCESSFULLY`,
    FETCH_CATEGORY_ACTIVITIES_FAILED: `${SCOPE}FETCH_CATEGORY_ACTIVITIES_FAILED`,
    FETCH_CATEGORY_ACTIVITIES_CANCELLED: `${SCOPE}FETCH_CATEGORY_ACTIVITIES_CANCELLED`,
    SET_CATEGORY_PRELOADED: `${SCOPE}SET_CATEGORY_PRELOADED`,

    SET_DESTINATION_ACTIVITIES_IS_LOADED: `${SCOPE}SET_DESTINATION_ACTIVITIES_IS_LOADED`,
    SET_DESTINATION_ACTIVITIES_HAS_MORE: `${SCOPE}SET_DESTINATION_ACTIVITIES_HAS_MORE`,
    SET_DESTINATION_ACTIVITIES_OFFSET: `${SCOPE}SET_DESTINATION_ACTIVITIES_OFFSET`,
    FETCH_DESTINATION_ACTIVITIES: `${SCOPE}FETCH_DESTINATION_ACTIVITIES`,
    FETCH_DESTINATION_ACTIVITIES_STARTED: `${SCOPE}FETCH_DESTINATION_ACTIVITIES_STARTED`,
    FETCH_DESTINATION_ACTIVITIES_SUCCESSFULLY: `${SCOPE}FETCH_DESTINATION_ACTIVITIES_SUCCESSFULLY`,
    FETCH_DESTINATION_ACTIVITIES_FAILED: `${SCOPE}FETCH_DESTINATION_ACTIVITIES_FAILED`,
    FETCH_DESTINATION_ACTIVITIES_CANCELLED: `${SCOPE}FETCH_DESTINATION_ACTIVITIES_CANCELLED`,
    SET_DESTINATION_PRELOADED: `${SCOPE}SET_DESTINATION_PRELOADED`,

    SET_RECOMMENDS_IS_LOADED: `${SCOPE}SET_RECOMMENDS_IS_LOADED`,
    RESET_RECOMMENDS: `${SCOPE}RESET_RECOMMENDS`,
    FETCH_RECOMMENDS: `${SCOPE}FETCH_RECOMMENDS`,
    FETCH_RECOMMENDS_STARTED: `${SCOPE}FETCH_RECOMMENDS_STARTED`,
    FETCH_RECOMMENDS_SUCCESSFULLY: `${SCOPE}FETCH_RECOMMENDS_SUCCESSFULLY`,
    FETCH_RECOMMENDS_FAILED: `${SCOPE}FETCH_RECOMMENDS_FAILED`,
    FETCH_RECOMMENDS_CANCELLED: `${SCOPE}FETCH_RECOMMENDS_CANCELLED`,

    SET_USER_IMAGES_IS_LOADED: `${SCOPE}SET_USER_IMAGES_IS_LOADED`,
    FETCH_USER_IMAGES_STARTED: `${SCOPE}FETCH_USER_IMAGES_STARTED`,
    FETCH_USER_IMAGES_SUCCESSFULLY: `${SCOPE}FETCH_USER_IMAGES_SUCCESSFULLY`,
    FETCH_USER_IMAGES_FAILED: `${SCOPE}FETCH_USER_IMAGES_FAILED`,
    FETCH_USER_IMAGES_CANCELLED: `${SCOPE}FETCH_USER_IMAGES_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

export const setQuery = (query) => ({
    type: ActionTypes.SET_QUERY,
    query,
});

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Itinerary Activities
 */
export const setItineraryActivitiesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_ITINERARY_ACTIVITIES_IS_LOADED,
    isLoaded,
});
export const setItineraryActivitiesHasMore = (hasMore) => ({
    type: ActionTypes.SET_ITINERARY_ACTIVITIES_HAS_MORE,
    hasMore,
});
export const setItineraryActivitiesOffset = (offset) => ({
    type: ActionTypes.SET_ITINERARY_ACTIVITIES_OFFSET,
    offset,
});
export const setItineraryActivitiesPromoPrices = (promoPrices = []) => ({
    type: ActionTypes.SET_ITINERARY_ACTIVITIES_PROMOPRICES,
    promoPrices,
});
export const fetchItineraryActivities = () => ({ type: ActionTypes.FETCH_ITINERARY_ACTIVITIES });
export const fetchItineraryActivitiesStarted = () => ({
    type: ActionTypes.FETCH_ITINERARY_ACTIVITIES_STARTED,
});
export const fetchItineraryActivitiesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_ITINERARY_ACTIVITIES_SUCCESSFULLY,
    res,
});
export const fetchItineraryActivitiesFailed = (error) => ({
    type: ActionTypes.FETCH_ITINERARY_ACTIVITIES_FAILED,
    error,
});
export const fetchItineraryActivitiesCancelled = () => ({
    type: ActionTypes.FETCH_ITINERARY_ACTIVITIES_CANCELLED,
});

export const setItineraryPreloaded = (preloaded) => ({
    type: ActionTypes.SET_ITINERARY_PRELOADED,
    preloaded,
});

/**
 * Category Activities
 */
export const setCategoryActivitiesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_CATEGORY_ACTIVITIES_IS_LOADED,
    isLoaded,
});
export const setCategoryActivitiesHasMore = (hasMore) => ({
    type: ActionTypes.SET_CATEGORY_ACTIVITIES_HAS_MORE,
    hasMore,
});
export const setCategoryActivitiesOffset = (offset) => ({
    type: ActionTypes.SET_CATEGORY_ACTIVITIES_OFFSET,
    offset,
});
export const fetchCategoryActivities = () => ({
    type: ActionTypes.FETCH_CATEGORY_ACTIVITIES,
});
export const fetchCategoryActivitiesStarted = () => ({
    type: ActionTypes.FETCH_CATEGORY_ACTIVITIES_STARTED,
});
export const fetchCategoryActivitiesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_CATEGORY_ACTIVITIES_SUCCESSFULLY,
    res,
});
export const fetchCategoryActivitiesFailed = (error) => ({
    type: ActionTypes.FETCH_CATEGORY_ACTIVITIES_FAILED,
    error,
});
export const fetchCategoryActivitiesCancelled = () => ({
    type: ActionTypes.FETCH_CATEGORY_ACTIVITIES_CANCELLED,
});

export const setCategoryPreloaded = (preloaded) => ({
    type: ActionTypes.SET_CATEGORY_PRELOADED,
    preloaded,
});

/**
 * Destination Activities
 */
export const setDestinationActivitiesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_DESTINATION_ACTIVITIES_IS_LOADED,
    isLoaded,
});
export const setDestinationActivitiesHasMore = (hasMore) => ({
    type: ActionTypes.SET_DESTINATION_ACTIVITIES_HAS_MORE,
    hasMore,
});
export const setDestinationActivitiesOffset = (offset) => ({
    type: ActionTypes.SET_DESTINATION_ACTIVITIES_OFFSET,
    offset,
});
export const fetchDestinationActivities = () => ({
    type: ActionTypes.FETCH_DESTINATION_ACTIVITIES,
});
export const fetchDestinationActivitiesStarted = () => ({
    type: ActionTypes.FETCH_DESTINATION_ACTIVITIES_STARTED,
});
export const fetchDestinationActivitiesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_DESTINATION_ACTIVITIES_SUCCESSFULLY,
    res,
});
export const fetchDestinationActivitiesFailed = (error) => ({
    type: ActionTypes.FETCH_DESTINATION_ACTIVITIES_FAILED,
    error,
});
export const fetchDestinationActivitiesCancelled = () => ({
    type: ActionTypes.FETCH_DESTINATION_ACTIVITIES_CANCELLED,
});

export const setDestinationPreloaded = (preloaded) => ({
    type: ActionTypes.SET_DESTINATION_PRELOADED,
    preloaded,
});

/**
 * Recommends
 */
export const setRecommendsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_RECOMMENDS_IS_LOADED,
    isLoaded,
});
export const fetchRecommends = () => ({ type: ActionTypes.FETCH_RECOMMENDS });
export const resetRecommends = () => ({ type: ActionTypes.RESET_RECOMMENDS });
export const fetchRecommendsStarted = () => ({ type: ActionTypes.FETCH_RECOMMENDS_STARTED });
export const fetchRecommendsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY,
    res,
});
export const fetchRecommendsFailed = (error) => ({
    type: ActionTypes.FETCH_RECOMMENDS_FAILED,
    error,
});
export const fetchRecommendsCancelled = () => ({
    type: ActionTypes.FETCH_RECOMMENDS_CANCELLED,
});

/**
 * UserImages
 */
export const setUserImagesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_USER_IMAGES_IS_LOADED,
    isLoaded,
});
export const fetchUserImagesStarted = () => ({ type: ActionTypes.FETCH_USER_IMAGES_STARTED });
export const fetchUserImagesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY,
    res,
});
export const fetchUserImagesFailed = (error) => ({
    type: ActionTypes.FETCH_USER_IMAGES_FAILED,
    error,
});
export const fetchUserImagesCancelled = () => ({
    type: ActionTypes.FETCH_USER_IMAGES_CANCELLED,
});
